module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 122);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return httpGetVcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return httpQuickLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return httpUploadValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpCheckUploadValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpAccountLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return httpGetPhoneCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return httpValidateCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return httpResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return httpPostAnswerRecord; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 是否显示图像验证码，短信验证码是否发送成功
 * @returns
 */
function httpGetVcode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/quick_login/generate_vcode/", {
    ...params
  });
}

/**
 * 登录流程，新用户注册并登录，老用户直接登录，返回登录是否成功
 * @returns
 */
function httpQuickLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/quick_login/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 获取上传短信内容信息(主动发短信流程内容获取)
 * @returns
 */
function httpUploadValidate(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/sms/upload/validate/", {
    ...params
  });
}

/**
 * 验证短信内容是否发送，并获取校验凭证
 * @returns
 */
function httpCheckUploadValidate(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/sms/upload/validate/", {
    ...params
  });
}

/**
 * 账号登录接口
 * @returns
 */
function httpAccountLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/login/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-发送手机/邮箱验证码
 * @returns
 */
function httpGetPhoneCode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/vcode/generate/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-验证验证码
 * @returns
 */
function httpValidateCode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/vcode/validate/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-设置密码
 * @returns
 */
function httpResetPassword(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/password/forget/", {
    ...params
  });
}

// 接口调用答题结束页引导, 新增自己的答题数据
function httpPostAnswerRecord(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post(`/app_api/common/api/answer_record/`, data);
}

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/drawer");

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/index.vue?vue&type=template&id=669609e5&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Popup",
    {
      staticClass: "mobile-login-popup",
      attrs: {
        "pop-visible": _vm.dialogVisible,
        title: "登录popup",
        "is-cancel": true
      },
      on: {
        "update:popVisible": function($event) {
          _vm.dialogVisible = $event
        },
        "update:pop-visible": function($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.closePop,
        open: function($event) {
          return _vm.setState(true)
        }
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("LoginHeader", {
            attrs: {
              "header-type": _vm.headerTypeVal,
              "browser-type": _vm.browserTypeVal,
              "login-type": _vm.loginTypeVal,
              "show-agree": _vm.showAgreeContent,
              "private-mode": _vm.privateMode
            },
            on: { onChange: _vm.loginTypeChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "popup-content",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          !_vm.privateMode
            ? _c("GuideContent", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.showAgreeContent &&
                      _vm.headerTypeVal === "guidePage" &&
                      (_vm.browserTypeVal === "isWeixin" ||
                        _vm.browserTypeVal === "isQQ"),
                    expression:
                      "\n                !showAgreeContent &&\n                    headerTypeVal === 'guidePage' &&\n                    (browserTypeVal === 'isWeixin' ||\n                        browserTypeVal === 'isQQ')\n            "
                  }
                ],
                attrs: {
                  "browser-type": _vm.browserTypeVal,
                  "redirect-url": _vm.redirectUrl,
                  "page-id": _vm.pageId,
                  "from-id": _vm.fromId,
                  "furl-parameter": _vm.furlParameter
                },
                on: {
                  clickPhone: function($event) {
                    return _vm.setHeaderType("loginPage")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("LoginContent", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !_vm.showAgreeContent &&
                  (_vm.headerTypeVal === "loginPage" ||
                    (_vm.browserTypeVal !== "isWeixin" &&
                      _vm.browserTypeVal !== "isQQ")),
                expression:
                  "\n                !showAgreeContent &&\n                    (headerTypeVal === 'loginPage' ||\n                        (browserTypeVal !== 'isWeixin' &&\n                            browserTypeVal !== 'isQQ'))\n            "
              }
            ],
            ref: "LoginContent",
            attrs: {
              "login-type": _vm.loginTypeVal,
              "browser-type": _vm.browserTypeVal,
              "next-url": _vm.nextUrl,
              "redirect-url": _vm.redirectUrl,
              "page-id": _vm.pageId,
              "from-id": _vm.fromId,
              accepted: _vm.accept,
              "is-login-redirect-link": _vm.isLoginRedirectLink,
              "furl-parameter": _vm.furlParameter,
              "private-mode": _vm.privateMode,
              "mini-app-login": _vm.miniAppLogin,
              "mini-query-obj": _vm.miniQueryObj
            },
            on: {
              setShowAgree: _vm.setShowAgreeContent,
              loginSuccess: _vm.emitLoginSuccess
            }
          }),
          _vm._v(" "),
          !_vm.privateMode
            ? _c("AgreeContent", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAgreeContent,
                    expression: "showAgreeContent"
                  }
                ],
                on: { setAgreeAccept: _vm.setAccept }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/index.vue?vue&type=template&id=669609e5&scoped=true&

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(4);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=template&id=c89101e6&scoped=true&
var vant_popupvue_type_template_id_c89101e6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WdDrawer",
    {
      attrs: {
        visible: _vm.visible,
        "with-header": false,
        direction: "btt",
        "append-to-body": true,
        size: "auto",
        "safe-area-inset-bottom": "",
        "wrapper-closable": _vm.closeMask,
        "modal-class": "picker-mask",
        "get-container": "body",
        "custom-class": "custom-van-popup"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.closed,
        open: _vm.open
      }
    },
    [
      _c("div", { staticClass: "custom-popup-content" }, [
        _c(
          "div",
          { staticClass: "slot-header" },
          [
            _vm._t("header", function() {
              return [
                _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
              ]
            }),
            _vm._v(" "),
            _c("span", { staticClass: "closed", on: { click: _vm.closed } })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "slot-content", style: { maxHeight: _vm.maxHeight } },
          [_vm._t("content")],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "slot-footer" }, [_vm._t("footer")], 2)
      ])
    ]
  )
}
var vant_popupvue_type_template_id_c89101e6_scoped_true_staticRenderFns = []
vant_popupvue_type_template_id_c89101e6_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=template&id=c89101e6&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/drawer.css"
var drawer_css_ = __webpack_require__(131);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/drawer"
var drawer_ = __webpack_require__(107);
var drawer_default = /*#__PURE__*/__webpack_require__.n(drawer_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=script&lang=js&



/* harmony default export */ var vant_popupvue_type_script_lang_js_ = ({
  components: {
    WdDrawer: drawer_default.a
  },
  props: {
    popVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "xxxx"
    },
    // 点击遮罩关闭
    closeMask: {
      type: Boolean,
      default: false
    },
    isCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      isSafari: false,
      footerHeight: 110
    };
  },
  computed: {
    icon() {
      return this.isCancel ? "close" : "collapse";
    },
    maxHeight() {
      const maxHeight = this.isSafari ? 174 : 134;
      return `calc(100vh - ${this.$slots.footer ? maxHeight + this.footerHeight : maxHeight}px)`;
    }
  },
  watch: {
    popVisible(val) {
      this.visible = val;
    },
    visible(val) {
      let observer = null;
      this.$nextTick(() => {
        if (val) {
          var _document;
          const targetNode = ((_document = document) === null || _document === void 0 ? void 0 : _document.querySelector(".slot-footer")) || null;
          if (targetNode && this.$slots.footer) {
            // 监听底部按钮高度
            const config = {
              attributes: true,
              childList: true,
              subtree: true
            };
            observer = new MutationObserver(mutationsList => {
              var _mutationsList$, _mutationsList$$targe;
              this.footerHeight = ((_mutationsList$ = mutationsList[0]) === null || _mutationsList$ === void 0 ? void 0 : (_mutationsList$$targe = _mutationsList$.target) === null || _mutationsList$$targe === void 0 ? void 0 : _mutationsList$$targe.clientHeight) || 0;
            });
            observer.observe(targetNode, config);
          }
        } else {
          observer && observer.disconnect();
        }
      });
    }
  },
  mounted() {
    this.visible = this.popVisible;
    const {
      isSafari
    } = Object(tools["b" /* distinguishUserAgentUtils */])(navigator.userAgent);
    this.isSafari = isSafari;
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    closed() {
      this.$emit("closed");
    },
    open() {
      this.$emit("open");
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var component_vant_popupvue_type_script_lang_js_ = (vant_popupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=style&index=0&id=c89101e6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/vant-popup.vue?vue&type=style&index=0&id=c89101e6&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/vant-popup.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  component_vant_popupvue_type_script_lang_js_,
  vant_popupvue_type_template_id_c89101e6_scoped_true_render,
  vant_popupvue_type_template_id_c89101e6_scoped_true_staticRenderFns,
  false,
  null,
  "c89101e6",
  null
  
)

/* harmony default export */ var vant_popup = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/login-header.vue?vue&type=template&id=de2e75ae&scoped=true&
var login_headervue_type_template_id_de2e75ae_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-header" }, [
    !_vm.showAgree &&
    _vm.headerType === "guidePage" &&
    (_vm.browserType === "isWeixin" || _vm.browserType === "isQQ") &&
    !_vm.privateMode
      ? _c("div", { staticClass: "header-content" }, [
          _vm._v("\n        登录问卷网\n    ")
        ])
      : !_vm.showAgree &&
        (_vm.headerType === "loginPage" ||
          (_vm.browserType !== "isWeixin" && _vm.browserType !== "isQQ"))
      ? _c("div", { staticClass: "header-content" }, [
          !_vm.privateMode
            ? _c(
                "div",
                {
                  class:
                    _vm.loginType === "quickLogin" ? "selected" : "notSelected",
                  on: {
                    click: function($event) {
                      return _vm.handleChangeTab("quickLogin")
                    }
                  }
                },
                [_vm._v("\n            快速登录\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class:
                _vm.loginType === "accountLogin" ? "selected" : "notSelected",
              on: {
                click: function($event) {
                  return _vm.handleChangeTab("accountLogin")
                }
              }
            },
            [_vm._v("\n            账号登录\n        ")]
          ),
          _vm._v(" "),
          !_vm.privateMode
            ? _c("div", {
                class:
                  _vm.loginType === "quickLogin"
                    ? "slider-box slider-left"
                    : "slider-box slider-right"
              })
            : _vm._e()
        ])
      : _vm.showAgree && !_vm.privateMode
      ? _c("div", { staticClass: "header-content" }, [
          _vm._v("\n        用户服务协议及隐私政策\n    ")
        ])
      : _vm._e()
  ])
}
var login_headervue_type_template_id_de2e75ae_scoped_true_staticRenderFns = []
login_headervue_type_template_id_de2e75ae_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/login-header.vue?vue&type=template&id=de2e75ae&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/login-header.vue?vue&type=script&lang=js&
/* harmony default export */ var login_headervue_type_script_lang_js_ = ({
  name: "LoginHeader",
  props: {
    headerType: {
      type: String,
      default: "guidePage"
    },
    loginType: {
      type: String,
      default: "quickLogin"
    },
    browserType: {
      type: String,
      default: "isOther"
    },
    // 展示用户协议
    showAgree: {
      type: Boolean,
      default: false
    },
    // 是否为部署版
    privateMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    handleChangeTab(type) {
      this.$emit("onChange", type);
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/login-header.vue?vue&type=script&lang=js&
 /* harmony default export */ var component_login_headervue_type_script_lang_js_ = (login_headervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/login-header.vue?vue&type=style&index=0&id=de2e75ae&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/login-header.vue?vue&type=style&index=0&id=de2e75ae&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/login-header.vue






/* normalize component */

var login_header_component = Object(componentNormalizer["a" /* default */])(
  component_login_headervue_type_script_lang_js_,
  login_headervue_type_template_id_de2e75ae_scoped_true_render,
  login_headervue_type_template_id_de2e75ae_scoped_true_staticRenderFns,
  false,
  null,
  "de2e75ae",
  null
  
)

/* harmony default export */ var login_header = (login_header_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=template&id=517976b8&scoped=true&
var guide_contentvue_type_template_id_517976b8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "guide-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-top" },
      [
        _c(
          "WdButton",
          {
            attrs: { type: "primary" },
            on: { click: _vm.handleClickThirdLogin }
          },
          [
            _c("div", { staticClass: "button-primary" }, [
              _c("span", {
                class: _vm.browserType === "isWeixin" ? "wx-btn" : "qq-btn"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "btn-text" }, [
                _vm._v(
                  _vm._s(_vm.browserType === "isWeixin" ? "微信登录" : "QQ登录")
                )
              ])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-bottom" },
      [
        _c("WdButton", { on: { click: _vm.handleClickPhoneLogin } }, [
          _c("div", { staticClass: "button-info" }, [
            _c("span", { staticClass: "phone-btn" }),
            _vm._v(" "),
            _c("span", { staticClass: "btn-text" }, [_vm._v("手机号登录")])
          ])
        ])
      ],
      1
    )
  ])
}
var guide_contentvue_type_template_id_517976b8_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "guide-image" }, [
      _c("div", { staticClass: "image-div" })
    ])
  }
]
guide_contentvue_type_template_id_517976b8_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=template&id=517976b8&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(0);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/mobile-login-popup/third-login.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取钉钉网页授权登录链接
function getDingdingLoginUrl() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/app_api/dingding/login_url/`);
}

// 飞书网页授权登录链接
function getFeishuLoginUrl() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/api/member/micro_app/feishu/mobile_login/`);
}

// 获取sessionid
function getSessionId() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/app_api/get_session_id/");
}

// 获取微信小程序url
function wechatLogin(params) {
  request = external_vue_default.a.prototype.commonRequest;
  const url = `/app_api/wx/urlscheme/`;
  return request.get(url, params);
}

// 跳转企微登录
function wxWorkLogin() {
  request = external_vue_default.a.prototype.commonRequest;
  const url = `/api/member/micro_app/business_weixin/oauth_url/`;
  return request.get(url);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=template&id=6b75ee91&scoped=true&
var toastvue_type_template_id_6b75ee91_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "w-toast-pop" } }, [
    !_vm.type
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "w-toast",
            class: _vm.customClass
          },
          [
            _c("span", { staticClass: "w-toast-text" }, [
              _vm._v(_vm._s(_vm.message))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "img-save-notice w-toast",
            class: _vm.customClass
          },
          [
            _c("svg-icon", {
              attrs: { width: "30", height: "30", "icon-name": "success" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.message))])
          ],
          1
        )
      : _vm._e()
  ])
}
var toastvue_type_template_id_6b75ee91_scoped_true_staticRenderFns = []
toastvue_type_template_id_6b75ee91_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=template&id=6b75ee91&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=script&lang=js&
/* harmony default export */ var toastvue_type_script_lang_js_ = ({
  name: "Toast",
  props: {
    type: {
      type: Boolean,
      default: false
    },
    message: String,
    className: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "middle"
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    customClass() {
      const classes = [];
      switch (this.position) {
        case "top":
          classes.push("is-placetop");
          break;
        case "bottom":
          classes.push("is-placebottom");
          break;
        default:
          classes.push("is-placemiddle");
      }
      console.log(this.position);
      classes.push(this.className);
      return classes.join(" ");
    }
  }
});
// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=script&lang=js&
 /* harmony default export */ var toast_toastvue_type_script_lang_js_ = (toastvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=style&index=0&id=6b75ee91&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=style&index=0&id=6b75ee91&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/toast/toast.vue






/* normalize component */

var toast_component = Object(componentNormalizer["a" /* default */])(
  toast_toastvue_type_script_lang_js_,
  toastvue_type_template_id_6b75ee91_scoped_true_render,
  toastvue_type_template_id_6b75ee91_scoped_true_staticRenderFns,
  false,
  null,
  "6b75ee91",
  null
  
)

/* harmony default export */ var toast = (toast_component.exports);
// CONCATENATED MODULE: ./packages/toast/index.js


let activeToastMessage = "";
const Toast = {};
const ToastConstructor = external_vue_default.a.extend(toast);
const toastPool = [];
const getAnInstance = () => {
  if (toastPool.length > 0) {
    const instance = toastPool[0];
    toastPool.splice(0, 1);
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement("div")
  });
};
const returnAnInstance = instance => {
  if (instance) {
    toastPool.push(instance);
  }
};
const removeDom = event => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};
ToastConstructor.prototype.close = function () {
  this.visible = false;
  this.$el.addEventListener("transitionend", removeDom);
  this.closed = true;
  activeToastMessage = "";
  returnAnInstance(this);
};
/* harmony default export */ var packages_toast = ({
  success(options) {
    return this.show(options, "success");
  },
  show() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const duration = options.duration || 3000;
    const currentToastMessage = typeof options === "string" ? options : options.message;
    // 正显示toast并且提示文案相同时return
    if (activeToastMessage === currentToastMessage) return;
    // 执行show时，关闭之前的toast
    const instance = getAnInstance();
    instance.close();
    instance.closed = false;
    activeToastMessage = currentToastMessage;
    clearTimeout(instance.timer);
    clearTimeout(instance.delayTimer);
    instance.message = currentToastMessage;
    instance.custom = options.custom;
    instance.position = options.position || "middle";
    instance.className = options.className || "";
    instance.callback = options.callback;
    instance.delay = options.delay || 0;
    instance.type = type;
    document.body.appendChild(instance.$el);
    external_vue_default.a.nextTick(function () {
      // delay show toast
      if (instance.delay > 0) {
        instance.delayTimer = setTimeout(() => {
          if (instance.closed) return;
          instance.visible = true;
        }, instance.delay);
      } else {
        instance.visible = true;
      }
      instance.visible = true;
      instance.$el.removeEventListener("transitionend", removeDom);
      if (duration !== -1) {
        instance.timer = setTimeout(() => {
          instance.close();
        }, duration);
      }
    });
    return instance;
  }
});
// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=script&lang=js&





/* harmony default export */ var guide_contentvue_type_script_lang_js_ = ({
  name: "GuideContent",
  components: {
    WdButton: button_default.a
  },
  props: {
    browserType: {
      type: String,
      default: "isWeixin"
    },
    // 第三方登录成功重定向的url
    redirectUrl: {
      type: String,
      default: "/m/"
    },
    // 用于微信登录url &page_id=${pageId}
    pageId: {
      type: String,
      default: ""
    },
    // 用于微信登录url &from_mid=${fromId}
    fromId: {
      type: String,
      default: ""
    },
    furlParameter: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    // 点击第三方登录
    handleClickThirdLogin() {
      if (this.browserType === "isWeixin") {
        // 微信登录流程
        this.wxLogin();
      } else if (this.browserType === "isQQ") {
        // qq登录流程
        this.openQQLogin();
      } else {
        packages_toast.show({
          position: "bottom",
          message: `browserType:${this.browserType}`
        });
      }
    },
    // 微信登录，跳转微信登录
    wxLogin() {
      getSessionId().then(res => {
        if (this.redirectUrl) {
          const furl = decodeURIComponent(this.redirectUrl);
          Object(cookie["c" /* set */])("login_redirect_url", encodeURIComponent(furl), 1);
        }
        const {
          session_id: sessionId
        } = res.data;
        let url = `/weixin/auth/?scope=snsapi_userinfo&back_url=${location.origin}/weixin/login/?web_site=wenjuan_mweb&sid=${sessionId}`;
        if (this.pageId) {
          url += `&page_id=${this.pageId}`;
        }
        if (this.fromId) {
          url += `&from_mid=${this.fromId}`;
        }
        if (this.furlParameter) {
          url += `&furl=${this.furlParameter}`;
        }
        window.location.href = url;
      }).catch(err => {
        packages_toast.show({
          position: "bottom",
          message: "获取sessionId失败"
        });
      });
    },
    // qq登录
    openQQLogin() {
      window.location.href = `/openapi/qq/?web_site=wenjuan_mweb&furl=${encodeURIComponent(this.redirectUrl)}`;
    },
    // 点击其他方式登录
    handleClickPhoneLogin() {
      this.$emit("clickPhone");
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var content_guide_contentvue_type_script_lang_js_ = (guide_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=style&index=0&id=517976b8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/guide-content.vue?vue&type=style&index=0&id=517976b8&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/guide-content.vue






/* normalize component */

var guide_content_component = Object(componentNormalizer["a" /* default */])(
  content_guide_contentvue_type_script_lang_js_,
  guide_contentvue_type_template_id_517976b8_scoped_true_render,
  guide_contentvue_type_template_id_517976b8_scoped_true_staticRenderFns,
  false,
  null,
  "517976b8",
  null
  
)

/* harmony default export */ var guide_content = (guide_content_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=template&id=7efeab63&scoped=true&
var login_contentvue_type_template_id_7efeab63_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loginType === "quickLogin",
              expression: "loginType === 'quickLogin'"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "phone-input" },
            [
              _c(
                "WdInput",
                {
                  attrs: { placeholder: "手机号", type: "tel" },
                  on: { input: _vm.quickLoginInput },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber"
                  }
                },
                [
                  _c("template", { slot: "prefix" }, [
                    _c("span", { staticClass: "phone-icon" })
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "login-code" },
            [
              _c(
                "WdInput",
                {
                  attrs: { placeholder: "验证码", maxlength: "6", type: "tel" },
                  on: { input: _vm.codeInput },
                  model: {
                    value: _vm.phoneCode,
                    callback: function($$v) {
                      _vm.phoneCode = $$v
                    },
                    expression: "phoneCode"
                  }
                },
                [
                  _c("template", { slot: "prefix" }, [
                    _c("span", { staticClass: "code-icon" })
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("CodeButton", {
                ref: "CodeButton",
                staticClass: "ml-8",
                attrs: {
                  active: !_vm.phoneNumberError,
                  "phone-number": _vm.phoneNumber
                },
                on: {
                  end: function($event) {
                    _vm.showSendText = true
                  },
                  codeUnusual: _vm.setMobileUnusual
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSendText,
                  expression: "showSendText"
                }
              ],
              staticClass: "login-tip"
            },
            [
              _vm._v("未收到验证码？"),
              _c(
                "span",
                { staticClass: "tip-button", on: { click: _vm.showSmsPopup } },
                [_vm._v("发送短信")]
              ),
              _vm._v("\n            自动验证")
            ]
          ),
          _vm._v(" "),
          _vm.mobileUnusual
            ? _c("span", { staticClass: "account-error" }, [
                _vm._v("您的账号存在异常，请更换账号或点击"),
                _c(
                  "a",
                  { attrs: { href: "https://www.wenjuan.com/s/UZBZJveegg2" } },
                  [_vm._v("进行申诉")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loginType === "accountLogin",
              expression: "loginType === 'accountLogin'"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "phone-input" },
            [
              _c("WdInput", {
                attrs: { placeholder: "手机号/邮箱" },
                on: { input: _vm.accountLoginInput },
                model: {
                  value: _vm.loginAccount,
                  callback: function($$v) {
                    _vm.loginAccount = $$v
                  },
                  expression: "loginAccount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "phone-input" },
            [
              _c("WdInput", {
                attrs: {
                  placeholder: "密码",
                  "show-password": "",
                  oncopy: "return false",
                  oncut: "return false"
                },
                on: { input: _vm.passwordInput },
                model: {
                  value: _vm.loginPassword,
                  callback: function($$v) {
                    _vm.loginPassword = $$v
                  },
                  expression: "loginPassword"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.accountUnusual
            ? _c("span", { staticClass: "account-error" }, [
                _vm._v("您的账号存在异常，请更换账号或点击"),
                _c(
                  "a",
                  { attrs: { href: "https://www.wenjuan.com/s/UZBZJveegg2" } },
                  [_vm._v("进行申诉")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-warp" },
        [
          _c(
            "WdButton",
            {
              staticClass: "login-button",
              attrs: { type: "primary", disabled: _vm.loginLoading },
              on: { click: _vm.handleLogin }
            },
            [_vm._v(_vm._s(_vm.loginLoading ? "登录中..." : "登录"))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "login-tip" }, [
        _vm._v(
          _vm._s(
            _vm.loginType === "quickLogin"
              ? "未注册手机号验证后自动创建问卷网账号"
              : ""
          )
        )
      ]),
      _vm._v(" "),
      !_vm.privateMode
        ? _c(
            "div",
            { staticClass: "third-login-warp" },
            [
              _c("ThirdLogin", {
                attrs: {
                  "browser-type": _vm.browserType,
                  "redirect-url": _vm.redirectUrl,
                  "page-id": _vm.pageId,
                  "from-id": _vm.fromId,
                  "furl-parameter": _vm.furlParameter,
                  "mini-app-login": _vm.miniAppLogin,
                  "mini-query-obj": _vm.miniQueryObj
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SmsPopup", {
        attrs: {
          "show-sms-popup": _vm.showSendSmsPopup,
          "phone-number": _vm.phoneNumber,
          "sms-content": _vm.smsContent,
          "sms-target": _vm.smsTarget
        },
        on: {
          "update:showSmsPopup": function($event) {
            _vm.showSendSmsPopup = $event
          },
          "update:show-sms-popup": function($event) {
            _vm.showSendSmsPopup = $event
          },
          checkSendMsgFailed: _vm.showSmsFailModal,
          smsPassLogin: _vm.smsSendLogin
        }
      })
    ],
    1
  )
}
var login_contentvue_type_template_id_7efeab63_scoped_true_staticRenderFns = []
login_contentvue_type_template_id_7efeab63_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=template&id=7efeab63&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input.css"
var input_css_ = __webpack_require__(18);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input"
var input_ = __webpack_require__(9);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: ./src/http/new-login/index.js
var new_login = __webpack_require__(10);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=template&id=c3140cde&scoped=true&
var code_buttonvue_type_template_id_c3140cde_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "auth-coder-content",
      class: _vm.active ? "active" : "",
      attrs: { disabled: _vm.sendLimit || !_vm.active },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.sendVcode.apply(null, arguments)
        }
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.vText) + "\n")]
  )
}
var code_buttonvue_type_template_id_c3140cde_scoped_true_staticRenderFns = []
code_buttonvue_type_template_id_c3140cde_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=template&id=c3140cde&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/js/manMachine.js

const TencentCaptchaAppId = "193603329";

// 展示滑块验证
function showCapthcha(resolve, reject) {
  const captcha1 = new window.TencentCaptcha(TencentCaptchaAppId, res => {
    const data = {
      rand_str: res.randstr,
      ticket: res.ticket
    };
    if (data.rand_str && data.ticket) {
      resolve(data);
    } else {
      reject(res);
    }
  });
  captcha1.show();
}
// 腾讯滑块验证
// eslint-disable-next-line import/prefer-default-export
function manMachineVerificationByTencent() {
  return new Promise((resolve, reject) => {
    if (window.TencentCaptcha) {
      return showCapthcha(resolve, reject);
    }
    Object(tools["j" /* loadJS */])("https://turing.captcha.qcloud.com/TCaptcha.js", () => {
      return showCapthcha(resolve, reject);
    });
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=script&lang=js&



/* harmony default export */ var code_buttonvue_type_script_lang_js_ = ({
  props: {
    active: {
      type: Boolean,
      default: false
    },
    phoneNumber: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentTimeout: 59,
      sendType: "default",
      timer: null,
      captchaSuccess: false // 腾讯验证结果
    };
  },

  computed: {
    vText() {
      const sendText = Object.freeze({
        default: "获取验证码",
        send: `${this.currentTimeout}s后获取`,
        reSend: "重新获取"
      });
      return sendText[this.sendType];
    },
    sendLimit() {
      return this.sendType === "send";
    }
  },
  methods: {
    // 发送验证码并判断是否展示滑块
    async sendVcode() {
      try {
        let data = {
          identifier: this.phoneNumber
        };

        // 腾讯滑块验证通过，带上验证通过参数
        if (this.captchaSuccess) {
          data = {
            identifier: this.phoneNumber,
            captcha_success: this.captchaSuccess
          };
        }
        const res = await Object(new_login["d" /* httpGetVcode */])(data);
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_show_captcha) {
            // 显示腾讯滑块
            this.tencentManMachineVerificatio();
          }

          // 发送验证码并开始倒计时
          if (res.data.is_vcode) {
            this.sendType = "send";
            this.refreshSeconds();
          }
        } else if (res.err_code == 300004) {
          // 账号被封禁逻辑
          this.$emit("codeUnusual", true);
        } else if (res.err_msg) {
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: res === null || res === void 0 ? void 0 : res.err_msg
          });
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        var _err$data, _err$data2;
        if (typeof err === "object" && ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.err_code) == 300004) {
          // 账号被封禁逻辑
          this.$emit("codeUnusual", true);
        } else if ((_err$data2 = err.data) !== null && _err$data2 !== void 0 && _err$data2.err_msg) {
          var _err$data3;
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: (_err$data3 = err.data) === null || _err$data3 === void 0 ? void 0 : _err$data3.err_msg
          });
        } else {
          return Promise.reject(err);
        }
      }
    },
    // 腾讯滑块验证逻辑
    tencentManMachineVerificatio() {
      manMachineVerificationByTencent().then(res => {
        // 调用发送验证码接口获取验证码
        this.captchaSuccess = true;
        this.sendVcode();
      }).catch(err => {
        this.captchaSuccess = false;
      });
    },
    // 刷新秒数
    refreshSeconds() {
      this.timer = setTimeout(() => {
        this.currentTimeout--;
        if (this.currentTimeout > 0) {
          this.refreshSeconds();
        } else {
          this.sendType = "reSend";
          this.$emit("end");
          this.currentTimeout = 59;
        }
      }, 1000);
    },
    clear() {
      clearTimeout(this.timer);
      this.currentTimeout = 59;
      this.sendType = "default";
      this.captchaSuccess = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var content_code_buttonvue_type_script_lang_js_ = (code_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=style&index=0&id=c3140cde&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/code-button.vue?vue&type=style&index=0&id=c3140cde&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/code-button.vue






/* normalize component */

var code_button_component = Object(componentNormalizer["a" /* default */])(
  content_code_buttonvue_type_script_lang_js_,
  code_buttonvue_type_template_id_c3140cde_scoped_true_render,
  code_buttonvue_type_template_id_c3140cde_scoped_true_staticRenderFns,
  false,
  null,
  "c3140cde",
  null
  
)

/* harmony default export */ var code_button = (code_button_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=template&id=35d08c59&scoped=true&
var sms_popupvue_type_template_id_35d08c59_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Popup",
    {
      staticClass: "mobile-login-popup",
      attrs: {
        "pop-visible": _vm.visible,
        title: "发短信验证手机号",
        "is-cancel": true
      },
      on: {
        "update:popVisible": function($event) {
          _vm.visible = $event
        },
        "update:pop-visible": function($event) {
          _vm.visible = $event
        },
        closed: function($event) {
          _vm.visible = false
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "popup-content",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showToast,
                  expression: "showToast"
                }
              ],
              staticClass: "loading-container",
              on: {
                touchmove: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "content-wrapper" }, [
                _c("div"),
                _vm._v(" "),
                _c("p", [_vm._v("手机验证中")])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row" }, [
            _c("div", { staticClass: "content-name" }, [_vm._v("使用手机")]),
            _vm._v(" "),
            _c("div", { staticClass: "content-value" }, [
              _vm._v(_vm._s(_vm.phoneNumber))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sms-content" },
            [
              _c("div", { staticClass: "content-row" }, [
                _c("div", { staticClass: "content-name" }, [
                  _vm._v("编辑短信")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-value" }, [
                  _vm._v(_vm._s(_vm.smsContent))
                ])
              ]),
              _vm._v(" "),
              _c(
                "wdButton",
                {
                  attrs: { id: "copyBtn", size: "small", type: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.copySms(_vm.smsContent)
                    }
                  }
                },
                [_vm._v("复制")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row" }, [
            _c("div", { staticClass: "content-name" }, [_vm._v("发送至")]),
            _vm._v(" "),
            _c("div", { staticClass: "content-value" }, [
              _vm._v(_vm._s(_vm.smsTarget))
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "sms-tips" }, [
            _vm._v("*短信费用由运营商收取")
          ]),
          _vm._v(" "),
          _c(
            "wdButton",
            { staticClass: "button-primary", attrs: { type: "primary" } },
            [
              _c("a", { attrs: { href: `sms:${_vm.smsTarget}` } }, [
                _vm._v("一键发送")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "wdButton",
            {
              staticClass: "button-info",
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.checkSendResult(10)
                }
              }
            },
            [_vm._v("我已发送")]
          )
        ],
        1
      )
    ]
  )
}
var sms_popupvue_type_template_id_35d08c59_scoped_true_staticRenderFns = []
sms_popupvue_type_template_id_35d08c59_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=template&id=35d08c59&scoped=true&

// EXTERNAL MODULE: external "clipboard"
var external_clipboard_ = __webpack_require__(39);
var external_clipboard_default = /*#__PURE__*/__webpack_require__.n(external_clipboard_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=script&lang=js&






/* harmony default export */ var sms_popupvue_type_script_lang_js_ = ({
  name: "SmsPopup",
  components: {
    Popup: vant_popup,
    WdButton: button_default.a
  },
  props: {
    showSmsPopup: {
      type: Boolean,
      default: false
    },
    phoneNumber: {
      type: String,
      default: ""
    },
    smsContent: {
      type: String,
      default: ""
    },
    smsTarget: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showContent: false,
      clipboard: null,
      // 剪切板
      showToast: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.showSmsPopup;
      },
      set(val) {
        this.$emit("update:showSmsPopup", val);
      }
    }
  },
  methods: {
    // 复制短信内容
    copySms(word) {
      if (this.clipboard) this.clipboard.destroy();
      this.clipboard = new external_clipboard_default.a("#copyBtn", {
        text: () => word
      });
      this.clipboard.on("success", () => {
        // this.$toast.show全局挂载有点问题 先单独引入
        packages_toast.show({
          position: "bottom",
          message: "复制成功"
        });
      });
      this.clipboard.on("error", () => {
        packages_toast.show({
          position: "bottom",
          message: "该浏览器不支持自动复制，请手动复制！"
        });
      });
    },
    // 主动验证弹框检查发送结果
    checkSendResult(requestNum) {
      if (requestNum === 10) {
        // 展示加载中toast
        this.showToast = true;
      }
      Object(new_login["b" /* httpCheckUploadValidate */])({
        use_for: "quick_login",
        phone: this.phoneNumber,
        content: this.smsContent
      }).then(res => {
        requestNum--;
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_sent) {
            // 拿到token信息掉登录接口
            this.$emit("smsPassLogin", res.data.token);
            // 关闭弹窗
            this.showToast = false;
            this.visible = false;
          } else if (requestNum > 0) {
            // 轮询
            setTimeout(() => {
              this.checkSendResult(requestNum);
            }, 1000);
          } else {
            // 展示验证失败弹框
            this.$emit("checkSendMsgFailed");
            this.showToast = false;
            this.visible = false;
          }
        } else {
          this.showToast = false;
        }
      }).catch(err => {
        var _err$data;
        this.showToast = false;
        if (typeof err === "object" && (_err$data = err.data) !== null && _err$data !== void 0 && _err$data.err_msg) {
          packages_toast.show({
            position: "bottom",
            message: err.data.err_msg
          });
        } else {
          return Promise.reject(err);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var component_sms_popupvue_type_script_lang_js_ = (sms_popupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=style&index=0&id=35d08c59&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/sms-popup.vue?vue&type=style&index=0&id=35d08c59&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/sms-popup.vue






/* normalize component */

var sms_popup_component = Object(componentNormalizer["a" /* default */])(
  component_sms_popupvue_type_script_lang_js_,
  sms_popupvue_type_template_id_35d08c59_scoped_true_render,
  sms_popupvue_type_template_id_35d08c59_scoped_true_staticRenderFns,
  false,
  null,
  "35d08c59",
  null
  
)

/* harmony default export */ var sms_popup = (sms_popup_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=template&id=c1e7705c&scoped=true&
var third_loginvue_type_template_id_c1e7705c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "third-login" }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.browserType === "isWeixin",
          expression: "browserType === 'isWeixin'"
        }
      ],
      staticClass: "login-type wx-login",
      on: { click: _vm.wxLogin }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.browserType === "isWxwork",
          expression: "browserType === 'isWxwork'"
        }
      ],
      staticClass: "login-type wx-work-login",
      on: { click: _vm.wxWorkLogin }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.browserType === "isDingding",
            expression: "browserType === 'isDingding'"
          }
        ],
        staticClass: "login-type",
        on: { click: _vm.dingLogin }
      },
      [_c("div", { staticClass: "third-inner ding-login" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.browserType === "isFeishu",
            expression: "browserType === 'isFeishu'"
          }
        ],
        staticClass: "login-type",
        on: { click: _vm.feishuLogin }
      },
      [_c("div", { staticClass: "third-inner feishu-login" })]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMiniAppIcon,
          expression: "showMiniAppIcon"
        }
      ],
      staticClass: "login-type wx-login",
      on: { click: _vm.showMiniProgram }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "login-type qq-login",
      on: {
        click: function($event) {
          return _vm.openQQSina("qq")
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "login-type sina-login",
      on: {
        click: function($event) {
          return _vm.openQQSina("sina")
        }
      }
    })
  ])
}
var third_loginvue_type_template_id_c1e7705c_scoped_true_staticRenderFns = []
third_loginvue_type_template_id_c1e7705c_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=template&id=c1e7705c&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/js/webviewRoute.js
const webviewRoutes = {
  list: {
    mLink: "/m/list/",
    miniLink: "/pages/template/index?target=plist"
  },
  edit: {
    mLink: "/m/edit/",
    miniLink: "/pages/projects/pages/pDetail"
  },
  account: {
    mLink: "/m/account/",
    miniLink: "/pages/projects/webview/webviewAccount"
  },
  preview: {
    mLink: "/m/preview/",
    miniLink: "/pages/projects/pages/webviewPreview"
  },
  index: {
    mLink: "/m/",
    miniLink: "/pages/template/index"
  },
  login: {
    mLink: "/m/login/",
    miniLink: "/pages/login"
  },
  search: {
    mLink: "/m/search/",
    miniLink: "/pages/template/pages/libSearch"
  },
  lib: {
    mLink: "/m/templates",
    miniLink: "/pages/template/pages/lib"
  },
  libDetail: {
    mLink: "/m/lib_detail/",
    miniLink: "/pages/template/pages/webviewLibDetail"
  },
  recommend: {
    mLink: "/m/lib/recommend/",
    miniLink: "/pages/template/pages/recommend"
  },
  topic: {
    mLink: "/m/topic",
    miniLink: "/pages/template/pages/TopicList"
  },
  topicDetail: {
    mLink: "/m/topic/",
    miniLink: "/pages/template/pages/webviewTopicDetail"
  },
  copy: {
    mLink: "/m/copy/",
    miniLink: "/pages/projects/pages/pCopy"
  },
  listSearch: {
    mLink: "/m/list/search",
    miniLink: "/pages/template/pages/projectSearch"
  },
  public: {
    mLink: "",
    miniLink: "/pages/projects/pages/webviewAnswerEnd"
  },
  publishShare: {
    mLink: "/m/share/",
    miniLink: "/pages/projects/pages/newShare"
  },
  publishResult: {
    mLink: "/m/result/",
    miniLink: "/pages/projects/pages/newShare"
  },
  publishBind: {
    mLink: "/m/publish/",
    miniLink: "/pages/projects/pages/bindMobile"
  },
  report: {
    mLink: "",
    miniLink: "/pages/projects/pages/webviewCollection"
  },
  theme: {
    mLink: "",
    miniLink: "/pages/projects/pages/topicSelect"
  },
  setting: {
    mLink: "/m/account/setting/",
    miniLink: "/pages/account/pages/setting"
  },
  contact: {
    mLink: "/m/contact-kf",
    miniLink: "/pages/serviceLink"
  },
  help: {
    mLink: "/m/help",
    miniLink: "/pages/helpcenter/pages/list"
  },
  helpDetail: {
    mLink: "/m/help/detail/",
    miniLink: "/pages/helpcenter/pages/detail"
  },
  recycle: {
    mLink: "/m/recycle",
    miniLink: "/pages/projects/pages/recycle"
  },
  mycollect: {
    mLink: "/m/mycollect",
    miniLink: "/pages/projects/pages/mycollect"
  },
  articleDetail: {
    mLink: "/m/article/",
    miniLink: "/pages/articles/pages/detail"
  },
  folder: {
    mLink: "/m/list/folder",
    miniLink: "/pages/projects/pages/folder"
  },
  limit: {
    mLink: "/m/audit/",
    miniLink: "/pages/projects/pages/limitwords"
  },
  questionSquare: {
    mLink: "/m/question_square/",
    miniLink: "/pages/projects/pages/qList"
  },
  qDetail: {
    mLink: "/m/question_square/detail/",
    miniLink: "/pages/projects/pages/qDetail"
  },
  importWord: {
    mLink: "/m/import/",
    miniLink: "/pages/projects/pages/textImport"
  },
  importHelp: {
    mLink: "/m/import/help/",
    miniLink: "/pages/projects/pages/textImportSample"
  },
  importPreview: {
    mLink: "/m/import/preview/",
    miniLink: "/pages/projects/pages/textImportPreview"
  },
  protocol: {
    mLink: "",
    miniLink: "/pages/projects/pages/webviewPrivacyPolicy"
  },
  test: {
    mLink: "",
    miniLink: "/pages/template/pages/testEnvironment"
  },
  reportDowload: {
    mLink: "",
    miniLink: "/pages/template/pages/webviewReportDownload"
  },
  reportShare: {
    mLink: "",
    miniLink: "/pages/projects/pages/webviewReportShare"
  },
  answer: {
    mLink: "",
    miniLink: "/pages/projects/pages/webviewAnswer"
  },
  404: {
    mLink: "/m/404",
    miniLink: "/pages/index"
  },
  projectSetting: {
    mLink: "/m/setting/",
    miniLink: "/pages/projectSetting/pSetting"
  },
  activity: {
    mLink: "/m/activity/",
    miniLink: "/pages/projects/pages/webviewAdBanner"
  },
  bean: {
    mLink: "",
    miniLink: "/pages/account/pages/rewards"
  },
  cooperate: {
    mLink: "/m/cooperate/",
    miniLink: "/pages/projects/pages/projectCooperate"
  },
  folderCooperate: {
    mLink: "/m/folder_cooperate/",
    miniLink: ""
  },
  sample: {
    mLink: "/m/activity/sample/",
    miniLink: "/pages/activity/sample"
  },
  gift: {
    mLink: "/m/activity/user_gift/",
    miniLink: "/pages/activity/gift"
  },
  coupons: {
    mLink: "/m/coupons/"
  },
  sampleService: {
    mLink: "/m/sample_service/",
    miniLink: "/pages/sample/sampleService"
  },
  sampleOrders: {
    mLink: "/m/sampleOrders/"
  },
  filePreview: {
    mLink: "",
    miniLink: "/pages/filePreview"
  }
};
/* harmony default export */ var webviewRoute = (webviewRoutes);
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/js/ua.js
/* harmony default export */ var ua = (userAgent => {
  const lowerCaseUa = window.userAgent.toLowerCase();
  const isTouTiaoMiniApp = lowerCaseUa.includes("toutiaomicroapp");
  const isQQMiniApp = lowerCaseUa.includes("qq") && lowerCaseUa.includes("miniprogram") && !lowerCaseUa.includes("micromessenger");
  const isBaiduMiniApp = lowerCaseUa.includes("baiduboxapp") && lowerCaseUa.includes("swan");
  const isWeixinMiniApp = lowerCaseUa.includes("micromessenger") && lowerCaseUa.includes("miniprogram");
  return {
    isEdge: window.userAgent.includes("Edge"),
    isFF: window.userAgent.includes("Firefox"),
    isOpera: window.userAgent.includes("Opera"),
    isBB: window.userAgent.includes("BlackBerry"),
    isChrome: window.userAgent.includes("Chrome"),
    isMaxthon: window.userAgent.includes("Maxthon"),
    isIos: /(iPhone|iPad|iPod|iOS)/i.test(window.userAgent),
    isSafari: window.userAgent.includes("Safari") && !window.userAgent.includes("Chrome"),
    isIE: window.userAgent.includes("compatible") && window.userAgent.includes("MSIE") && !window.userAgent.includes("Opera"),
    isMobile: /(iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(window.userAgent),
    isAndroidApp: lowerCaseUa.includes("android_app/"),
    isIosApp: lowerCaseUa.includes("wenjuan/"),
    isApp: lowerCaseUa.includes("wenjuan/") || lowerCaseUa.includes("android_app/"),
    isTeacherApp: lowerCaseUa.includes("campusteacher/") || lowerCaseUa.includes("campusstudent/"),
    isWeixin: lowerCaseUa.match(/MicroMessenger/i) == "micromessenger",
    isWeibo: lowerCaseUa.match(/WeiBo/i) == "weibo",
    isWxwork: lowerCaseUa.match(/wxwork/i) == "wxwork",
    isQQ: lowerCaseUa.match(/QQ/i) == "qq" || lowerCaseUa.includes("tencenttraveler") || lowerCaseUa.includes("qqbrowse"),
    isHarmony: lowerCaseUa.includes("harmony_wenjuanwrap"),
    isAndroid: (lowerCaseUa.match(/android/i) == "android" || lowerCaseUa.match(/adr/i) == "adr") && lowerCaseUa != "android_app/1.0.0",
    isUc: lowerCaseUa.includes("ucbrowser"),
    isCloudpay: lowerCaseUa.includes("unionpay"),
    isDingTalk: lowerCaseUa.includes("dingtalk"),
    isFeishu: lowerCaseUa.includes("feishu"),
    isTencentMeeting: lowerCaseUa.includes("tencent_wemeet"),
    isQuark: lowerCaseUa.includes("quark"),
    isTouTiaoMiniApp,
    isQQMiniApp,
    isBaiduMiniApp,
    isWeixinMiniApp,
    isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp
  };
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/js/miniAppUrlscheme.js




// query转obj
function queryToObject(queryStr) {
  const obj = {};
  queryStr = queryStr.split("?")[1] || queryStr;
  queryStr.split("&").forEach(item => {
    const queryArr = item.split("=");
    obj[queryArr[0]] = queryArr[1];
  });
  return obj;
}
function typeOf(obj) {
  const {
    toString
  } = Object.prototype;
  const map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  };
  return map[toString.call(obj)];
}
function deepCopy(data) {
  const t = typeOf(data);
  let o;
  if (t === "array") {
    o = [];
  } else if (t === "object") {
    o = {};
  } else {
    return data;
  }
  if (t === "array") {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === "object") {
    for (const i in data) {
      o[i] = deepCopy(data[i]);
    }
  }
  return o;
}
function getQueryString(obj) {
  const arr = [];
  Object.keys(obj).forEach(key => {
    arr.push(`${key}=${obj[key]}`);
  });
  if (arr.length) {
    return `${arr.join("&")}`;
  }
  return "";
}
function uniteRoute() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    key,
    params,
    query,
    miniQuery,
    mQuery,
    route = "push",
    customMLink = "",
    customMiniLink = "",
    miniRouteType = "navigateTo"
  } = data;
  const {
    isMiniApp
  } = ua(window.navigator.userAgent);
  const currentVal = deepCopy(webviewRoute[key]);
  // const hasMiniCookie = getCookie("is_mini_login");
  const hasMiniCookie = Object(cookie["b" /* get */])("appname");
  if (currentVal && route !== "back") {
    if (params) {
      currentVal.mLink += params;
    }
    if (query) {
      currentVal.miniLink = currentVal.miniLink || "";
      currentVal.mLink += `?${getQueryString(query)}`;
      currentVal.miniLink += `?${getQueryString(query)}`;
    }
    if (miniQuery && (isMiniApp || route === "getRoute")) {
      currentVal.miniLink += (currentVal.miniLink.includes("?") ? "&" : "?") + getQueryString(miniQuery);
    }
    if (mQuery && (!isMiniApp || !webviewRoute[key].miniLink || route === "getRoute")) {
      currentVal.mLink += (currentVal.miniLink.includes("?") ? "&" : "?") + getQueryString(mQuery);
    }
    if (customMLink) {
      currentVal.mLink = customMLink;
    }
    // 没有miniLink，小程序跳转到commonwebview
    if (!webviewRoute[key].miniLink) {
      currentVal.miniLink = `/pages/commonwebview?url=${encodeURIComponent(currentVal.mLink)}`;
    }
    if (customMiniLink) {
      currentVal.miniLink = customMiniLink;
    }
    if (route === "getRoute") {
      return {
        miniLink: currentVal.miniLink,
        mLink: currentVal.mLink
      };
    }
  }
}
const getMiniAppPathByRedirect = function () {
  let redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let fissionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let copyAssess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  const {
    scene,
    scene_type: sceneType,
    collect,
    joinId,
    share_id: shareId,
    pid
  } = queryToObject(redirect);
  const miniAppPathMapping = {
    "/m/edit/new": () => {
      return {
        key: "edit",
        miniQuery: {
          pid: "new",
          scene: scene || "survey"
        }
      };
    },
    "/m/copy": () => {
      return {
        key: "copy",
        miniQuery: {
          scene_type: sceneType
        }
      };
    },
    "/m/import": () => {
      return {
        key: "importWord",
        miniQuery: {
          scene_type: sceneType
        }
      };
    },
    "/m/edit/copy": () => {
      return {
        key: "edit",
        miniQuery: {
          action: "copy",
          copyid: pid
        }
      };
    },
    "/m/question_square/detail": () => {
      const id = redirect.split("m/question_square/detail/")[1];
      return {
        key: "qDetail",
        miniQuery: {
          id
        }
      };
    },
    "/m/question_square": () => {
      return {
        key: "questionSquare",
        miniQuery: {
          joinId
        }
      };
    },
    "/mobile/report/statistical": () => {
      return {
        key: "reportShare",
        miniQuery: {
          shareId
        }
      };
    },
    "/m/lib_detail": () => {
      const id = redirect.split("/lib_detail/")[1].split("/")[0];
      const miniQuery = {
        id
      };
      if (collect) {
        miniQuery.collect = collect;
      }
      return {
        key: "libDetail",
        miniQuery
      };
    },
    "/s/": () => {
      const query = redirect.split("/s/")[1];
      const [shortId, queryStr] = query.split("/?");
      return {
        key: "answer",
        miniQuery: {
          shortId: `${shortId}&${queryStr}`
        }
      };
    }
  };
  let miniAppPath = "/pages/template/index";
  if (redirect) {
    const keys = Object.keys(miniAppPathMapping);
    for (let i = 0; i < keys.length; i++) {
      if (redirect.includes(keys[i])) {
        const data = miniAppPathMapping[keys[i]]();
        const {
          miniLink
        } = uniteRoute({
          route: "getRoute",
          ...data
        });
        console.log(miniLink);
        miniAppPath = miniLink || miniAppPath;
        break;
      }
    }
  } else if (fissionId) {
    miniAppPath = `/pages/template/index?pageKey=list&fissionId=${fissionId}`;
  } else if (copyAssess) {
    miniAppPath = `/pages/template/index?pageKey=list&copyAssess=${copyAssess}`;
  }
  return {
    path: miniAppPath
  };
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=script&lang=js&




/* harmony default export */ var third_loginvue_type_script_lang_js_ = ({
  name: "ThirdLogin",
  props: {
    browserType: {
      type: String,
      default: "isOther"
    },
    redirectUrl: {
      type: String,
      default: "/m/list/"
    },
    // 用于微信登录url &page_id=${pageId}
    pageId: {
      type: String,
      default: ""
    },
    // 用于微信登录url &from_mid=${fromId}
    fromId: {
      type: String,
      default: ""
    },
    furlParameter: {
      type: String,
      default: ""
    },
    // 是否显示微信小程序登录
    miniAppLogin: {
      type: Boolean,
      default: true
    },
    // 获取小程序url需要的参数，原在页面路由中获取，登录弹出需要传进来，非必传
    miniQueryObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    showMiniAppIcon() {
      if (this.miniAppLogin && !["isWeixin", "isWxwork", "isDingding", "isFeishu"].includes(this.browserType)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    // 新浪qq登录
    openQQSina(type) {
      window.location.href = `/openapi/${type}/?web_site=wenjuan_mweb&furl=${encodeURIComponent(this.redirectUrl)}`;
    },
    // 微信登录，跳转微信登录
    wxLogin() {
      getSessionId().then(res => {
        if (this.redirectUrl) {
          const furl = decodeURIComponent(this.redirectUrl);
          Object(cookie["c" /* set */])("login_redirect_url", encodeURIComponent(furl), 1);
        }
        const {
          session_id: sessionId
        } = res.data;
        let url = `/weixin/auth/?scope=snsapi_userinfo&back_url=${location.origin}/weixin/login/?web_site=wenjuan_mweb&sid=${sessionId}`;
        if (this.pageId) {
          url += `&page_id=${this.pageId}`;
        }
        if (this.fromId) {
          url += `&from_mid=${this.fromId}`;
        }
        if (this.furlParameter) {
          url += `&furl=${this.furlParameter}`;
        }
        window.location.href = url;
      }).catch(err => {
        packages_toast.show({
          position: "bottom",
          message: "获取sessionId失败"
        });
      });
    },
    // 企业微信登录，跳转页面
    wxWorkLogin() {
      // let appid = "wwceea0dcae348b5e3";
      // if (window.location.href.indexOf("t1.wenjuan.com") >= 0) {
      //     appid = "ww0e10236af2a1f34f";
      // }
      // if (window.location.href.indexOf("wxtest01.wenjuan.com") >= 0) {
      //     appid = "ww9f7abc4d998f9283";
      // }
      // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&response_type=code&scope=snsapi_base&state=&redirect_uri=${location.origin}%2Fwx%2Fauth_login%2F%3Fsource%3Dmobile#wechat_redirect`;
      wxWorkLogin().then(res => {
        console.log("企微登录res", res);
        window.location.href = res.data;
      });
    },
    // 钉钉登录，跳转页面
    dingLogin() {
      getDingdingLoginUrl().then(res => {
        window.location.href = res.data;
      }).catch(err => {
        packages_toast.show({
          position: "bottom",
          message: "获取钉钉授权链接失败"
        });
      });
    },
    // 飞书登录，跳转页面
    feishuLogin() {
      getFeishuLoginUrl().then(res => {
        const {
          data
        } = res;
        window.location.href = data.redirect_url;
      }).catch(err => {
        packages_toast.show({
          position: "bottom",
          message: "获取飞书授权链接失败"
        });
      });
    },
    async showMiniProgram() {
      window.gio && window.gio("track", "m_wechat_icon_click");
      const url = await this.getUrlScheme();
      if (url) {
        window.location.href = url;
      }
    },
    // 获取微信小程序跳转url
    async getUrlScheme() {
      const {
        utm_extern: utmExtern,
        plan,
        utm_source: utmSource,
        redirect,
        fission_id: fissionId,
        copy_assess: copyAssess
      } = this.miniQueryObj;
      const params = {
        path: "pages/silentLogin"
      };
      const {
        path
      } = getMiniAppPathByRedirect(redirect, fissionId, copyAssess);
      if (path) {
        const query = `redirect=${encodeURIComponent(path)}`;
        params.query = encodeURIComponent(query);
      }
      const urlSchemeData = {};
      if (utmExtern) {
        params.utm_extern = utmExtern;
        urlSchemeData.utm_extern = utmExtern;
      }
      if (plan) {
        params.plan = plan;
        urlSchemeData.plan = plan;
      }
      if (utmSource) {
        params.utm_source = utmSource;
        urlSchemeData.utm_source = utmSource;
      }
      const originReferer = Object(cookie["b" /* get */])("origin_referer");
      const originPath = Object(cookie["b" /* get */])("origin_path");
      if (originReferer) {
        params.origin_referer = originReferer;
        urlSchemeData.origin_referer = originReferer;
      }
      if (originPath) {
        params.origin_path = originPath;
        urlSchemeData.origin_path = originPath;
      }
      window.gio && window.gio("track", "urlscheme_api");
      let url = "";
      try {
        const res = await wechatLogin(params);
        if (res.status_code == 1 && res.status == 200) {
          url = res.data.url_scheme;
        }
      } catch (error) {
        console.log(error);
      }
      return url;
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=script&lang=js&
 /* harmony default export */ var content_third_loginvue_type_script_lang_js_ = (third_loginvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=style&index=0&id=c1e7705c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/third-login.vue?vue&type=style&index=0&id=c1e7705c&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/third-login.vue






/* normalize component */

var third_login_component = Object(componentNormalizer["a" /* default */])(
  content_third_loginvue_type_script_lang_js_,
  third_loginvue_type_template_id_c1e7705c_scoped_true_render,
  third_loginvue_type_template_id_c1e7705c_scoped_true_staticRenderFns,
  false,
  null,
  "c1e7705c",
  null
  
)

/* harmony default export */ var third_login = (third_login_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/modal/index.vue?vue&type=template&id=209b3825&scoped=true&
var modalvue_type_template_id_209b3825_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c("Overlay", {
        model: {
          value: _vm.visible,
          callback: function($$v) {
            _vm.visible = $$v
          },
          expression: "visible"
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modal" }, on: { "after-leave": _vm.afterLeave } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible"
                }
              ],
              staticClass: "modal-content-wrapper",
              on: {
                touchmove: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              !_vm.modalType
                ? [
                    _vm.title
                      ? _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.title))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.content
                      ? _c("div", {
                          staticClass: "content",
                          domProps: { innerHTML: _vm._s(_vm.content) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-part" }, [
                      _vm.showCancelState
                        ? _c(
                            "button",
                            {
                              staticClass: "cancel",
                              on: { click: _vm.cancelFun }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.cancelText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "confirm",
                          on: { click: _vm.confirmFun }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.confirmText) +
                              "\n                    "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.bottomTip
                      ? _c("div", { staticClass: "bottom-tip" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.bottomTip) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ]
                : [
                    _vm.title
                      ? _c(
                          "div",
                          { staticClass: "modal-title" },
                          [
                            _c("svg-icon", {
                              attrs: {
                                "icon-name": `modal-${_vm.icon}`,
                                width: "18",
                                height: "18"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.title))
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.content
                      ? _c("div", {
                          staticClass: "modal-content",
                          domProps: { innerHTML: _vm._s(_vm.content) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "confirm-btn" }, [
                      _c("button", { on: { click: _vm.confirmFun } }, [
                        _vm._v(_vm._s(_vm.confirmText))
                      ])
                    ])
                  ]
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var modalvue_type_template_id_209b3825_scoped_true_staticRenderFns = []
modalvue_type_template_id_209b3825_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/modal/index.vue?vue&type=template&id=209b3825&scoped=true&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/overlay/index.vue?vue&type=template&id=5187d9a1&scoped=true&
var overlayvue_type_template_id_5187d9a1_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "popup-mask" }, on: { "after-leave": _vm.afterLeave } },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "m-popup-mask",
        style: {
          "z-index": _vm.zIndex,
          backgroundColor: _vm.maskBgColor,
          transition: `opacity ${_vm.duration}s`
        },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.close.apply(null, arguments)
          },
          touchmove: _vm.touchmove
        }
      })
    ]
  )
}
var overlayvue_type_template_id_5187d9a1_scoped_true_staticRenderFns = []
overlayvue_type_template_id_5187d9a1_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/overlay/index.vue?vue&type=template&id=5187d9a1&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/overlay/index.vue?vue&type=script&lang=js&
/* harmony default export */ var overlayvue_type_script_lang_js_ = ({
  name: "WenjuanAnswerOverlay",
  props: {
    zIndex: {
      type: Number,
      default: 9999
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    },
    // 默认关闭销毁组件
    destroy: {
      type: Boolean,
      default: true
    },
    maskBgColor: {
      type: String,
      default: "rgba(0, 0, 0, 0.7)"
    },
    duration: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val;
        if (val && this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      },
      immediate: true
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    afterLeave() {
      if (this.destroy && this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    touchmove(e) {
      e.preventDefault();
    }
  }
});
// CONCATENATED MODULE: ./packages/overlay/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_overlayvue_type_script_lang_js_ = (overlayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/overlay/index.vue?vue&type=style&index=0&id=5187d9a1&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/overlay/index.vue?vue&type=style&index=0&id=5187d9a1&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/overlay/index.vue






/* normalize component */

var overlay_component = Object(componentNormalizer["a" /* default */])(
  packages_overlayvue_type_script_lang_js_,
  overlayvue_type_template_id_5187d9a1_scoped_true_render,
  overlayvue_type_template_id_5187d9a1_scoped_true_staticRenderFns,
  false,
  null,
  "5187d9a1",
  null
  
)

/* harmony default export */ var overlay = (overlay_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/modal/index.vue?vue&type=script&lang=js&

/* harmony default export */ var modalvue_type_script_lang_js_ = ({
  components: {
    Overlay: overlay
  },
  data() {
    return {
      icon: "",
      modalType: false,
      // 类型是否带icon
      visible: false,
      title: "",
      content: "",
      cancelText: "取消",
      confirmText: "确定",
      bottomTip: "",
      type: "confirm" // notice 只有一个确认按钮，confirm 有cancel案由
    };
  },

  computed: {
    showCancelState() {
      return this.type === "confirm";
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    cancelFun() {
      this.visible = false;
      this.cancel && this.cancel();
    },
    confirmFun() {
      this.visible = false;
      this.confirm && this.confirm();
    },
    show() {
      this.visible = true;
    },
    afterLeave() {
      setTimeout(() => {
        this.$destroy();
      }, 1000);
    },
    toJSON() {}
  }
});
// CONCATENATED MODULE: ./packages/modal/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_modalvue_type_script_lang_js_ = (modalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/modal/index.vue?vue&type=style&index=0&id=209b3825&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/modal/index.vue?vue&type=style&index=0&id=209b3825&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/modal/index.vue






/* normalize component */

var modal_component = Object(componentNormalizer["a" /* default */])(
  packages_modalvue_type_script_lang_js_,
  modalvue_type_template_id_209b3825_scoped_true_render,
  modalvue_type_template_id_209b3825_scoped_true_staticRenderFns,
  false,
  null,
  "209b3825",
  null
  
)

/* harmony default export */ var modal = (modal_component.exports);
// CONCATENATED MODULE: ./packages/modal/modal.js

const modalObj = {
  install(Vue) {
    const modalInstance = Vue.extend(modal);
    let currentMsg;
    let instance;
    const initInstance = selector => {
      currentMsg = new modalInstance();
      const msgBoxEl = currentMsg.$mount().$el;
      document.querySelector(selector).appendChild(msgBoxEl);
    };
    Vue.prototype.$modal = {
      message(options) {
        if (!instance) {
          const selector = options.selector ? options.selector : "body";
          initInstance(selector);
        }
        Object.assign(currentMsg, options);
        return currentMsg.show();
      },
      success(options) {
        return this.message(Object.assign(options, {
          icon: "success",
          modalType: true,
          confirmText: options.confirmText || "好的"
        }));
      },
      error(options) {
        return this.message(Object.assign(options, {
          icon: "error",
          modalType: true,
          confirmText: options.confirmText || "好的"
        }));
      },
      warning(options) {
        return this.message(Object.assign(options, {
          icon: "warning",
          modalType: true,
          confirmText: options.confirmText || "好的"
        }));
      }
    };
  }
};
/* harmony default export */ var modal_modal = (modalObj);
// EXTERNAL MODULE: ./src/http/private/index.js
var http_private = __webpack_require__(62);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=script&lang=js&












external_vue_default.a.use(modal_modal);
/* harmony default export */ var login_contentvue_type_script_lang_js_ = ({
  name: "LoginContent",
  components: {
    WdInput: input_default.a,
    WdButton: button_default.a,
    SmsPopup: sms_popup,
    ThirdLogin: third_login,
    CodeButton: code_button
  },
  inject: ["appendParamsFn"],
  props: {
    loginType: {
      type: String,
      default: "quickLogin"
    },
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/m/"
    },
    // 第三方登录成功重定向的url
    redirectUrl: {
      type: String,
      default: "/m/"
    },
    // 浏览器类型
    browserType: {
      type: String,
      default: "isOther"
    },
    // 用于微信登录url &page_id=${pageId}
    pageId: {
      type: String,
      default: ""
    },
    // 用于微信登录url &from_mid=${fromId}
    fromId: {
      type: String,
      default: ""
    },
    // 是否同意用户协议
    accepted: {
      type: Boolean,
      default: false
    },
    isLoginRedirectLink: {
      type: Boolean,
      default: false
    },
    furlParameter: {
      type: String,
      default: ""
    },
    // 是否为部署版
    privateMode: {
      type: Boolean,
      default: false
    },
    // 是否显示微信小程序登录
    miniAppLogin: {
      type: Boolean,
      default: true
    },
    // 获取小程序url需要的参数，原在页面路由中获取，登录弹出需要传进来，非必传
    miniQueryObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showSendSmsPopup: false,
      // 主动发送短信popup
      phoneNumber: "",
      // 快速登录-手机号
      phoneCode: "",
      // 快速登录-验证码
      phoneNumberError: true,
      // 手机号有误
      phoneNumberErrorMsg: "请输入手机号",
      // 手机号错误信息
      showSendText: false,
      // 展示主动发送短信验证入口
      loginAccount: "",
      // 账号登录-账号
      loginPassword: "",
      // 账号登录-密码
      accountError: true,
      // 账号有误
      accountErrorMsg: "请输入手机号或邮箱",
      // 手机号错误信息
      quickLoginToken: "",
      // 快速登录token
      loginLoading: false,
      // 登陆中。。。
      smsContent: "",
      // 短信验证内容
      smsTarget: "",
      // 短信验证目标手机号
      showAgreement: false,
      // 展示用户协议弹窗
      mobileUnusual: false,
      // 账号异常-快速登录
      accountUnusual: false // 账号异常-账号登录
    };
  },

  watch: {
    accepted(val) {
      // 如果同意用户协议的话，调用登录接口走登录逻辑
      if (val) {
        this.handleQuickLogin();
      }
    }
  },
  methods: {
    // 主动发送短信流程
    showSmsPopup() {
      // 校验手机号格式
      this.checkMobile();
      if (this.phoneNumberError) {
        return packages_toast.show({
          position: "bottom",
          message: this.phoneNumberErrorMsg
        });
      }
      Object(new_login["h" /* httpUploadValidate */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          // 获取短信内容和目标手机号
          this.smsContent = res.data.content;
          this.smsTarget = res.data.channel;
          // 主动发送短信弹窗
          this.showSendSmsPopup = true;
        }
      }).catch(err => {
        var _err$data;
        this.pending = false;
        if (typeof err === "object" && (_err$data = err.data) !== null && _err$data !== void 0 && _err$data.err_msg) {
          packages_toast.show({
            position: "bottom",
            message: err.data.err_msg
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 点击登录
    handleLogin() {
      if (this.privateMode) {
        // 部署版账号登录
        this.privateLogin();
        return false;
      }
      if (this.loginType === "quickLogin") {
        // 快速登录
        this.handleQuickLogin("fromBtn");
      } else if (this.loginType === "accountLogin") {
        // 账号登录
        this.handleAccountLogin();
      }
    },
    // 快速登录
    handleQuickLogin(str) {
      // 正在登录。。。
      if (this.loginLoading) {
        return;
      }
      // 校验手机号格式
      this.checkMobile();
      if (this.phoneNumberError) {
        return packages_toast.show({
          position: "bottom",
          message: this.phoneNumberErrorMsg
        });
      }

      // 校验是否输入验证码
      if (!this.phoneCode && str === "fromBtn") {
        return packages_toast.show({
          position: "bottom",
          message: "请输入验证码"
        });
      }
      this.loginLoading = true;
      // 如果是登录按钮点击的登录，置空token，避免之前自主验证生成的token影响登录
      if (str === "fromBtn") {
        this.quickLoginToken = "";
      }
      const data = {
        identifier: this.phoneNumber
      };
      if (this.quickLoginToken) {
        Object.assign(data, {
          token: this.quickLoginToken
        });
      }
      if (this.accepted) {
        Object.assign(data, {
          agree_agreement: true
        });
      }
      if (this.phoneCode) {
        Object.assign(data, {
          vcode: this.phoneCode
        });
      }
      this.appendParamsFn(data);
      // 新用户注册并登录，老用户直接登录，返回登录是否成功
      Object(new_login["f" /* httpQuickLogin */])(data).then(res => {
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_new_member) {
            // 新用户，展示用户协议弹框
            this.showAgreement = true;
            this.$emit("setShowAgree", true);
            this.loginLoading = false;
          }
          if (res.data.is_login) {
            this.$emit("loginSuccess", "quick-login");
            if (!this.isLoginRedirectLink) {
              // 登录成功该跳转跳转，该刷新页面刷新页面
              typeof this.nextUrl === "function" ? this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
            }
            setTimeout(() => {
              this.loginLoading = false;
            }, 2000);
          }
        } else if (res.err_code == 300004) {
          // 账号被封禁逻辑
          this.loginLoading = false;
          this.mobileUnusual = true;
        } else {
          this.loginLoading = false;
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: res === null || res === void 0 ? void 0 : res.err_msg
          });
        }
      }).catch(err => {
        var _err$data2, _err$data3;
        this.loginLoading = false;
        if (typeof err === "object" && ((_err$data2 = err.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.err_code) == 300004) {
          // 账号被封禁逻辑
          this.mobileUnusual = true;
        } else if (typeof err === "object" && (_err$data3 = err.data) !== null && _err$data3 !== void 0 && _err$data3.err_msg) {
          var _err$data4;
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: (_err$data4 = err.data) === null || _err$data4 === void 0 ? void 0 : _err$data4.err_msg
          });
        } else {
          packages_toast.show({
            position: "bottom",
            message: "网络异常，请重新登录"
          });
          return Promise.reject(err);
        }
      });
    },
    // 账号密码登录
    handleAccountLogin() {
      // 正在登录。。。
      if (this.loginLoading) {
        return;
      }

      // 校验账号格式
      this.checkUserName();
      if (this.accountError) {
        return packages_toast.show({
          position: "bottom",
          message: this.accountErrorMsg
        });
      }
      if (!this.loginPassword) {
        return packages_toast.show({
          position: "bottom",
          message: "请输入密码"
        });
      }
      this.loginLoading = true;
      Object(new_login["a" /* httpAccountLogin */])({
        account: this.loginAccount,
        password: this.loginPassword
      }).then(res => {
        if (res.status === 200 && res.status_code === 1) {
          this.loginLoading = false;
          this.$emit("loginSuccess", "account-login");
          if (!this.isLoginRedirectLink) {
            // 登录成功该跳转跳转，该刷新页面刷新页面
            typeof this.nextUrl === "function" ? this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
          }
          setTimeout(() => {
            this.loginLoading = false;
          }, 2000);
        } else if (res.err_code == 300004) {
          // 账号被封禁逻辑
          this.loginLoading = false;
          this.accountUnusual = true;
        } else {
          this.loginLoading = false;
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: res === null || res === void 0 ? void 0 : res.err_msg
          });
        }
      }).catch(err => {
        var _err$data5, _err$data6;
        this.loginLoading = false;
        if (typeof err === "object" && ((_err$data5 = err.data) === null || _err$data5 === void 0 ? void 0 : _err$data5.err_code) == 300004) {
          // 账号被封禁逻辑
          this.accountUnusual = true;
        } else if (typeof err === "object" && (_err$data6 = err.data) !== null && _err$data6 !== void 0 && _err$data6.err_msg) {
          var _err$data7;
          // 接口报错
          packages_toast.show({
            position: "bottom",
            message: (_err$data7 = err.data) === null || _err$data7 === void 0 ? void 0 : _err$data7.err_msg
          });
        } else {
          packages_toast.show({
            position: "bottom",
            message: "网络异常，请重新登录"
          });
          return Promise.reject(err);
        }
      });
    },
    // 快速登陆-手机号输入
    quickLoginInput(val) {
      this.phoneNumber = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
      this.mobileUnusual = false;
      this.checkMobile();
    },
    // 手机号校验
    checkMobile() {
      this.phoneNumber = this.phoneNumber.trim();
      const domestic = /^1[3456789][0-9]{9}$/;
      const foreign = /^\+[0-9]{1,20}$/;
      if (this.phoneNumber == "") {
        this.phoneNumberErrorMsg = "请输入手机号";
        this.phoneNumberError = true;
        return;
      }
      if (!domestic.test(this.phoneNumber)) {
        if (!foreign.test(this.phoneNumber)) {
          this.phoneNumberErrorMsg = "手机号格式有误";
          this.phoneNumberError = true;
          return;
        }
      }
      this.phoneNumberError = false;
    },
    // 验证码输入
    codeInput() {
      this.phoneCode = String(this.phoneCode || "").replace(/\D/g, "");
    },
    // 账号登录-账号输入
    accountLoginInput(val) {
      this.loginAccount = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
      this.accountUnusual = false;
    },
    // 账号登录-密码输入
    passwordInput(val) {
      this.loginPassword = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
    },
    // 账号校验
    checkUserName() {
      this.loginAccount = this.loginAccount.trim();
      let isUser = "";
      const domestic = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const foreign = /^[\u4e00-\u9fa5]|[\w]|[\d]|\-|\_|\.$/;
      for (let i = 0; i < this.loginAccount.length; i++) {
        isUser = foreign.test(this.loginAccount[i]);
        if (isUser == false) {
          break;
        }
      }
      if (this.loginAccount == "") {
        this.accountErrorMsg = "请输入手机号或邮箱";
        this.accountError = true;
        return;
      }
      if (!domestic.test(this.loginAccount) && isUser == false) {
        this.accountErrorMsg = "账号格式有误";
        this.accountError = true;
        return;
      }
      this.accountError = false;
    },
    // 验证短信失败，展示弹窗
    showSmsFailModal() {
      this.$modal.message({
        title: "验证失败",
        confirmText: "重新发送",
        cancelText: "更换手机号",
        content: `系统未收到您手机号${this.phoneNumber}发送的短信，请重新发送短信或更换手机号`,
        confirm: () => {
          this.showSendSmsPopup = true;
        }
      });
    },
    // 短信验证成功，调用登录接口
    smsSendLogin(token) {
      // 接收短信验证成功返回的token
      this.quickLoginToken = token;
      // 登录方法
      this.handleQuickLogin();
    },
    // 账号异常-快速登录
    setMobileUnusual(val) {
      this.mobileUnusual = val;
    },
    // 部署版登录
    privateLogin() {
      if (this.loginLoading) {
        return;
      }

      // 校验账号格式
      this.checkUserName();
      if (this.accountError) {
        return packages_toast.show({
          position: "bottom",
          message: this.accountErrorMsg
        });
      }
      if (!this.loginPassword) {
        return packages_toast.show({
          position: "bottom",
          message: "请输入密码"
        });
      }
      this.loginLoading = true;
      Object(http_private["a" /* httpLogin */])({
        account: this.loginAccount,
        password: this.loginPassword
      }).then(res => {
        if (res.data.is_success) {
          // loginSuccessRedirectUrl(res, this.$route.query);
          this.$emit("loginSuccess", "account-login");
          if (!this.isLoginRedirectLink) {
            // 登录成功该跳转跳转，该刷新页面刷新页面
            typeof this.nextUrl === "function" ? this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
          }
        } else {
          const errMsg = (res === null || res === void 0 ? void 0 : res.err_msg) || "登录失败";
          this.$toast.show(errMsg);
          this.loginLoading = false;
        }
      }).catch(err => {
        this.loginLoading = false;
        // eslint-disable-next-line default-case
        switch (err.err_code) {
          case 300004:
            this.$toast.show("您的账号存在异常，请联系管理员");
            return;
        }
        const errMsg = err.err_msg || "登录失败";
        this.$toast.show(errMsg);
      });
    },
    // 重置登录内容
    resetLogin() {
      this.phoneNumber = "";
      this.phoneCode = "";
      this.phoneNumberError = true;
      this.showSendText = false;
      this.loginAccount = "";
      this.loginPassword = "";
      this.quickLoginToken = "";
      this.mobileUnusual = false;
      this.accountUnusual = false;
      this.$refs.CodeButton.clear();
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var content_login_contentvue_type_script_lang_js_ = (login_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=style&index=0&id=7efeab63&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/login-content.vue?vue&type=style&index=0&id=7efeab63&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/login-content.vue






/* normalize component */

var login_content_component = Object(componentNormalizer["a" /* default */])(
  content_login_contentvue_type_script_lang_js_,
  login_contentvue_type_template_id_7efeab63_scoped_true_render,
  login_contentvue_type_template_id_7efeab63_scoped_true_staticRenderFns,
  false,
  null,
  "7efeab63",
  null
  
)

/* harmony default export */ var login_content = (login_content_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=template&id=4858a320&scoped=true&
var agree_contentvue_type_template_id_4858a320_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "agree-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "agree-operation" },
      [
        _c(
          "WdButton",
          {
            staticClass: "operation-button",
            attrs: { type: "info" },
            on: {
              click: function($event) {
                return _vm.agree(false)
              }
            }
          },
          [_vm._v("不同意")]
        ),
        _vm._v(" "),
        _c(
          "WdButton",
          {
            staticClass: "operation-button",
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                return _vm.agree(true)
              }
            }
          },
          [_vm._v("同意")]
        )
      ],
      1
    )
  ])
}
var agree_contentvue_type_template_id_4858a320_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "agree-info" }, [
      _c("span", [
        _vm._v(
          "感谢您信任并使用问卷网提供的在线调研服务，我们非常重视您的个人信息和隐私保护。依照最新法律要求，我们制定了用户协议、隐私政策，请您务必仔细阅读"
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-button",
          attrs: {
            href: "https://www.wenjuan.com/register/protocol",
            target: "_blank"
          }
        },
        [_vm._v("《问卷网服务协议》")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("及")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-button",
          attrs: {
            href: "https://www.wenjuan.com/about/ystk",
            target: "_blank"
          }
        },
        [_vm._v("《隐私政策》")]
      ),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "，并确认了解我们对您个人信息的处理规则，包括我们会收集您个人信息的类型、我们如何收集、使用、储存您的个人信息，以及您所拥有的各项权利等事项。"
        ),
        _c("br"),
        _c("br")
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "如果您是未满18周岁的未成年人，请您通知您的监护人共同阅读上述材料。"
        )
      ])
    ])
  }
]
agree_contentvue_type_template_id_4858a320_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=template&id=4858a320&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=script&lang=js&


/* harmony default export */ var agree_contentvue_type_script_lang_js_ = ({
  name: "AgreeContent",
  components: {
    WdButton: button_default.a
  },
  props: {},
  data() {
    return {
      showContent: false
    };
  },
  methods: {
    // 同意/不同意用户协议
    agree(val) {
      this.$emit("setAgreeAccept", val);
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var content_agree_contentvue_type_script_lang_js_ = (agree_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=style&index=0&id=4858a320&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/agree-content.vue?vue&type=style&index=0&id=4858a320&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/component/content/agree-content.vue






/* normalize component */

var agree_content_component = Object(componentNormalizer["a" /* default */])(
  content_agree_contentvue_type_script_lang_js_,
  agree_contentvue_type_template_id_4858a320_scoped_true_render,
  agree_contentvue_type_template_id_4858a320_scoped_true_staticRenderFns,
  false,
  null,
  "4858a320",
  null
  
)

/* harmony default export */ var agree_content = (agree_content_component.exports);
// EXTERNAL MODULE: ./packages/tools.js
var packages_tools = __webpack_require__(8);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/index.vue?vue&type=script&lang=js&







/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "MobileLoginPopup",
  components: {
    Popup: vant_popup,
    LoginHeader: login_header,
    GuideContent: guide_content,
    LoginContent: login_content,
    AgreeContent: agree_content
  },
  provide() {
    return {
      appendParamsFn: packages_tools["default"].appendLoginParams
    };
  },
  props: {
    // 弹框显隐
    visible: {
      type: Boolean,
      default: false
    },
    // 登录成功路由跳转的URL或者触发的方法
    nextUrl: {
      type: [String, Function],
      default: "/m/"
    },
    // 第三方登录成功重定向的url
    redirectUrl: {
      type: String,
      default: "/m/"
    },
    // 用于微信登录url &page_id=${pageId}
    pageId: {
      type: String,
      default: ""
    },
    // 用于微信登录url &from_mid=${fromId}
    fromId: {
      type: String,
      default: ""
    },
    // 是否需要微信登陆回调
    isLoginRedirectLink: {
      type: Boolean,
      default: false
    },
    // 第三方登录的参数
    furlParameter: {
      type: String,
      default: ""
    },
    // 是否为部署版
    privateMode: {
      type: Boolean,
      default: false
    },
    // 是否显示微信小程序登录
    miniAppLogin: {
      type: Boolean,
      default: true
    },
    // 获取小程序url需要的参数，原在页面路由中获取，登录弹出需要传进来，非必传
    miniQueryObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showContent: false,
      headerTypeVal: "guidePage",
      // 页面类型：guidePage-登录问卷网，loginPage-快速/账号登录，agreePage-用户协议
      loginTypeVal: "quickLogin",
      // 登录类型: quickLogin-快速登录，accountLogin-账号登录
      showAgreeContent: false,
      // 是否展示用户协议页
      accept: false // 是否同意用户协议
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("close");
      }
    },
    // 浏览器类型
    browserTypeVal() {
      const {
        isWeixin,
        isQQ,
        isWxwork,
        isDingding,
        isFeishu
      } = Object(tools["b" /* distinguishUserAgentUtils */])();

      // 企微会判断为微信，优先判断企微
      if (isWxwork) {
        return "isWxwork";
      }
      if (isWeixin) {
        return "isWeixin";
      }
      if (isQQ) {
        return "isQQ";
      }
      if (isDingding) {
        return "isDingding";
      }
      if (isFeishu) {
        return "isFeishu";
      }
      return "isOther";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 发送弹窗弹出埋点
        window.gio && window.gio("track", "m_login_popnew");
      }
    }
  },
  created() {
    if (this.privateMode) {
      // 部署版只有账号登录
      this.loginTypeChange("accountLogin");
    }
  },
  methods: {
    // 登录方式tab切换
    loginTypeChange(val) {
      this.loginTypeVal = val;
    },
    // 页面切换
    setHeaderType(val) {
      this.headerTypeVal = val;
    },
    setState() {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$emit("update:showPopup", type);
      this.$emit(type ? "open" : "close", type);
    },
    // 设置用户协议显隐
    setShowAgreeContent(val) {
      this.showAgreeContent = val;
    },
    // 设置是否同意协议
    setAccept(val) {
      // 同意或者不同意，都需要关闭用户协议
      this.setShowAgreeContent(false);
      this.accept = val;
    },
    // 快速/账号登录发射事件
    emitLoginSuccess(val) {
      this.$emit("loginSuccess", val);
    },
    // 关闭弹窗,重置弹窗
    closePop() {
      this.headerTypeVal = "guidePage";
      this.loginTypeVal = "quickLogin";
      this.showAgreeContent = false;
      this.accept = false;
      this.$refs.LoginContent.resetLogin();
      this.dialogVisible = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/mobile-login-popup/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var mobile_login_popup_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/mobile-login-popup/src/index.vue?vue&type=style&index=0&id=669609e5&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/index.vue?vue&type=style&index=0&id=669609e5&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/mobile-login-popup/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  mobile_login_popup_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "669609e5",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/mobile-login-popup/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var mobile_login_popup = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/drawer.css");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input.css");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("clipboard");

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isNotEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isWxMiniApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return insertHTML; });
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    const ua = userAgent || window.navigator.userAgent;
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isWeibo: ua.toLowerCase().match(/WeiBo/i) == "weibo",
      isWxwork: ua.toLowerCase().match(/wxwork/i) == "wxwork",
      isQQ: ua.toLowerCase().match(/QQ/i) == "qq",
      isAndroidApp: ua.toLowerCase() == "android_app/1.0.0",
      isAndroid: (ua.toLowerCase().match(/android/i) == "android" || ua.toLowerCase().match(/adr/i) == "adr") && ua.toLowerCase() != "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.toLowerCase().match(/android_app\//i) == "android_app/" || ua.toLowerCase().match(/wenjuan\//i) == "wenjuan/",
      isBaiying: ua.toLowerCase().match(/Baiying/i) == "baiying",
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.toLowerCase().match(/tencent_wemeet/i) == "tencent_wemeet",
      isMac: /macintosh|mac os x/i.test(ua)
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window, _window$navigator, _window$navigator$use;
    const ua = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  var exdate;
  var domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toGMTString();
  } else {
    // expiredays为Nubmer类型或者未设置
    var newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toGMTString();
  }
  document.cookie = c_name + '=' + escape(value) + ';expires=' + exdate + ';path=/;domain=' + domain;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + '=');
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(';', c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return '';
}
function del(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = get(name);
  var domain = getParseDomain();
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/;domain=' + domain;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
function getParseDomain(beforeDomain) {
  let hostname = location.hostname.toLocaleLowerCase();
  let domain = beforeDomain || hostname;
  let reWenjuan = /.wenjuan.com$/;
  var reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reWenjuan.test(domain)) {
    domain = '.wenjuan.com';
  } else if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain == 'localhost') {
    domain = hostname;
  } else {
    domain = '.' + domain;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  var reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitPrivateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpLogin; });
/* unused harmony export httpPostAnswerRecord */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
// 部署版相关接口

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 提交部署版需求登记
// eslint-disable-next-line import/prefer-default-export
function submitPrivateInfo(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/plugin/api/v1/deploy_version/try/", data);
}

/**
 * 登录(部署版)
 * @param {object} params
 * @returns
 */
function httpLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/deployment/member/login/", params);
}

// 接口调用答题结束页引导, 新增自己的答题数据
function httpPostAnswerRecord(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/app_api/common/api/answer_record/", params);
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
          keys[_key] = arguments[_key];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      regfromsource,
      regfrommid
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      regfromsource,
      regfrommid
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input");

/***/ })

/******/ })["default"];